import { useCallback } from 'react'
import { useTranslation } from 'next-i18next'

import useSettingsFormContext from '~/hooks/useSettingsFormContext'
import { InputPhoneNumber } from '~/components/InputPhoneNumber'
import { InputV2 } from '~/components/InputV2'
import { countryData } from '~/shared/constants/locale.const'
import { isValidPhoneNumberInput } from '~/utils/helpers'
import { UserRole } from '~/types/user-info-types'

export default function PersonalInfo({ role }: { role: string }): React.ReactElement {
  const { t } = useTranslation(role === UserRole.TUTOR ? 'tutorPanel' : 'studentPanel')
  const { fields, errors, setFields } = useSettingsFormContext()

  const onFullNameChange = useCallback(
    (val) => {
      setFields((prevState) => ({ ...prevState, fullName: val }))
    },
    [setFields],
  )

  const handleOnCountryCodeChange = (code: string): void => {
    const selectedCountry = countryData.find((country) => {
      return country.code === code
    })

    if (selectedCountry) {
      setFields((prevState) => ({
        ...prevState,
        countryCallingCode: selectedCountry.callingCode,
        countryCode: selectedCountry.code,
      }))
    }
  }

  const handleOnPhoneNumberChange = (phoneNumber: string): void => {
    const numberWithoutCallerCode = phoneNumber.slice(fields.countryCallingCode.length + 1)

    if (isValidPhoneNumberInput(numberWithoutCallerCode)) {
      setFields((prevState) => ({
        ...prevState,
        phone: numberWithoutCallerCode,
      }))
    }
  }

  return (
    <div>
      <InputV2
        autoComplete="name"
        fieldErrors={errors.fullName}
        label={t('settings.labelFullName')}
        name="fullName"
        setValue={onFullNameChange}
        type="text"
        value={fields.fullName}
      />
      <InputPhoneNumber
        autoComplete="off"
        countryCode={fields.countryCode}
        fieldErrors={errors.phone}
        label={t('settings.labelPhoneNumber')}
        name="phoneNumber"
        setCountryCode={(newCode) => handleOnCountryCodeChange(newCode)}
        setValue={(val) => handleOnPhoneNumberChange(val)}
        type="text"
        value={`${fields.countryCallingCode} ${fields.phone}`}
      />
    </div>
  )
}
